import { alpha, Slider } from "@mui/material";
import { COLOR_BLACK } from "helpers/colors";
import { useVideoVolumn } from "helpers/useVideoVolumn";
import { VolumeHigh, VolumeMedium, VolumeOff } from "mdi-material-ui";
import React, { useState } from "react";

import PlayerButton from "./PlayerButton";

export default function VolumeButton({ enabled }) {
  const [volume, volumeSet] = useVideoVolumn();
  const volumeState = volume === 0 ? "off" : volume <= 30 ? "medium" : "high";
  const [volumnHover, volumnHoverSet] = useState(false);

  return (
    <>
      <PlayerButton
        title="Volume"
        onHoveringChange={volumnHoverSet}
        disabled={!enabled}
        onClick={() => {
          if (volumeState === "off") {
            volumeSet(30);
          } else if (volumeState === "medium") {
            volumeSet(100);
          } else {
            volumeSet(0);
          }
        }}
        icon={
          <>
            {!enabled && <VolumeOff />}
            {enabled &&
              {
                off: <VolumeOff />,
                medium: <VolumeMedium />,
                high: <VolumeHigh />,
              }[volumeState]}
          </>
        }
        decorators={
          <div
            style={{
              position: "absolute",
              width: 100,
              right: 0,
              top: 0,
              bottom: 0,
              transform: "translateX(100%)",
              display: "flex",
              alignItems: "center",
              opacity: volumnHover ? 1 : 0,
              pointerEvents: volumnHover ? "auto" : "none",
              transition: "opacity 0.2s",
              paddingInline: 12,
              backgroundColor: alpha(COLOR_BLACK, 0.5),
              borderRadius: 999,
              zIndex: 1,
            }}
          >
            <Slider
              size="small"
              color="inherit"
              value={volume}
              onChange={(_, value) => volumeSet(value)}
              sx={{ py: 0, display: "block" }}
            />
          </div>
        }
      />
    </>
  );
}
